export const getContentGroupData = state => {
  if (!(state.data && !state.data.pending)) return { contentGroups: [], categories: []}
  const { userId } = state.data.user
  const contentGroups = state.data.contentGroups.filter(contentGroup => {
    return contentGroup.GroupUsers.some(user => user.userId === userId)
  })
  const categories = []
  const assignedIds = {}
  // get array of unique categories from the groups
  contentGroups.forEach(group => {
    group.GroupCategories.forEach(category => {
      if (!assignedIds[category.categoryID]) {
        assignedIds[category.categoryID] = true
        categories.push(category)
      }
    })
  })
  return {contentGroups, categories}
}

/**
 * 
 * @param {Object} state redux state
 * @param {string[]} type the redux action type(s) to check pending requests on
 * @returns {boolean} true if any request exists in the request reducer and is currently pending
 */
export const getHasRequestPending = (state, type) => {
  if (Array.isArray(type)) {
    return type.some(requestType => getHasRequestPending(state, requestType))
  }
  return state.request[type] && state.request[type].pending === true
}

export const getHasRequestError = (state, type) => {
  return state.request[type] &&
    state.request[type].pending === false &&
    state.request[type].error && state.request[type].error.message
}
